import Hub from '../hub.js';
import { LoginForm, RegisterForm, ResetPasswordForm } from './account-forms.js';
import { on } from 'delegated-events';

const Portal = (function () {

    const Selectors = {
        PAGE: '.js-page-wrap',
        ELEMENT: '.js-portal',
        DRAWER: '.drawer',
        PORTAL_CONTENT: '[data-portal="content"]',
        PORTAL_OPEN: '[data-portal="open"]',
        PORTAL_CLOSE: '[data-portal="close"]'
    };

    const ClassNames = {
        ACTIVE: 'is-active',
        PORTAL_ACTIVE: 'has-portal'
    };

    class Portal {
        constructor() {
            this.isOpen = false;
            this.scrollPosition = 0;
            this.page = document.querySelector(Selectors.PAGE);
            this.portal = document.querySelector(Selectors.ELEMENT);
            this.drawers = document.querySelectorAll(Selectors.DRAWER);
            this.container = document.querySelector(Selectors.PORTAL_CONTENT);
            this.addEvents();
            this.subscribe();
            this.clickOutside = this.handleClickOutside.bind(this);
        }

        afterContentChanged() {
            document.body.classList.toggle(ClassNames.PORTAL_ACTIVE, this.isOpen);
            this.page.classList.toggle(ClassNames.PORTAL_ACTIVE, this.isOpen);
            this.drawers.forEach(item => {
                item.classList.toggle(ClassNames.PORTAL_ACTIVE, this.isOpen);
            });
            this.portal.classList.toggle(ClassNames.ACTIVE, this.isOpen);

            if (window.innerWidth < 1280) {
                window.scrollTo(0, this.isOpen ? 0 : this.scrollPosition);
            }            
        }

        addEvents() {
            on('click', Selectors.PORTAL_CLOSE, this.handleClickClose.bind(this));
            on('click', Selectors.PORTAL_OPEN, this.handleClickOpen.bind(this));
        }

        open(type) {
            this.isOpen = true;
            this.scrollPosition = window.pageYOffset;

            window.setTimeout(() => {
                this.createComponent(type);
            }, 0)
           
            document.addEventListener('click', this.clickOutside);
        }

        createComponent(type) {
            const el = this.container.children[0];

            if (type === 'login') {
                new LoginForm(el, true);
            } else if (type === 'register') {
                new RegisterForm(el, true);
            } else if (type === 'reset-password') {
                new ResetPasswordForm(el, true);
            }

            this.afterContentChanged();
        }

        close() {
            this.isOpen = false;

            document.removeEventListener('click', this.clickOutside);
            this.afterContentChanged();
        }

        subscribe() {
            Hub.subscribe(Hub.PORTAL_CLOSE, this.close.bind(this));
            Hub.subscribe(Hub.PORTAL_OPEN, this.handleSubscribeOpen.bind(this));
        }

        handleSubscribeOpen(type) {
            this.open(type);
        }

        handleClickOutside(event) {
            const isClickInside = this.portal.contains(event.target);

            if (!isClickInside) {
                this.handleClickClose(event);
            }
        }

        handleClickOpen(event) {
            const element = event.currentTarget;
            const type = element.getAttribute('data-portal-content');
            this.open(type);
       
            event.preventDefault();
        }

        handleClickClose(event) {
            this.close();

            event.preventDefault();
        }
    }

    return new Portal();

})();

export default Portal;
